<h1 mat-dialog-title>{{(data?.title | translate) || 'CONFIRM' | translate}}</h1>
<div mat-dialog-content>
  <p><span [innerHTML]="data?.message  | translate"></span></p>
  <br>
  <div fxLayout="row" fxLayoutAlign="end">
    <div fxFlex><button mat-raised-button [mat-dialog-close]="true" class="mr-1" cdkFocusInitial color="primary" autofocus>{{'YES' | translate: {Default:'Yes'} }}</button></div>
    <div fxFlex="nogrow"><button mat-raised-button [mat-dialog-close]="false" class="mr-1">{{'NO' | translate: {Default:'No'} }}</button></div>
  </div>
</div>